import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class LoggerService extends Service
{
	@tracked logs = {};
	@tracked logVersion = 0;

	logMessage(logName, message)
	{
		const timestamp = new Date().toLocaleTimeString();
		console.log(`${timestamp} ${logName}: ${message}`);
		const currentLog = this.logs[logName] || [];
		const logEntry = { timestamp, message };
		// Create new object reference to trigger reactivity
		this.logs = {
			...this.logs,
			[logName]: [...currentLog, logEntry]
		};
		// Increment version to ensure consumers re-render
		this.logVersion++;
	}

	getLog(logName)
	{
		// Access logVersion to establish tracking dependency
		this.logVersion;
		return this.logs[logName] || [];
	}

	clearLog(logName)
	{
		const newLogs = { ...this.logs };
		delete newLogs[logName];
		this.logs = newLogs;
		this.logVersion++;
	}
}
